var map = {
	"./icon_all.svg": 8934,
	"./icon_autoplay.svg": 7535,
	"./icon_first.svg": 4696,
	"./icon_full.svg": 3789,
	"./icon_last.svg": 7025,
	"./icon_more.svg": 3178,
	"./icon_music.svg": 1762,
	"./icon_next.svg": 6881,
	"./icon_nomusic.svg": 533,
	"./icon_pause.svg": 7229,
	"./icon_previous.svg": 4806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;